<template>
  <div>
    <!-- TODO improve colors handling -->
    <button
      class="btn flex items-center justify-center full-height caps-text block col-12 btn-cta p2"
      :class="[
        btnColor ? `btn-${btnColor}` : '',
        {'disabled': disabled, 'pointer': !disabled},
      ]"
      @click="action"
    >
      <i v-if="iconLeft" :class="iconLeft" class="mr1 icon-mb-4"></i>
      <b class="btn-cta-text" :class="[textSize]">
        {{ text }}
      </b>
      <i v-if="iconRight" :class="iconRight" class="ml1 icon-mb-4"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'Continuez'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    btnColor: {
      type: String,
      default: 'red'
    },
    iconRight: {
      type: String,
      default: ''
    },
    iconLeft: {
      type: String,
      default: ''
    },
    textSize: {
      type: String,
      default: 'normal'
    },
    action: Function
  }
};
</script>
<style>

.btn-cta {
  height: 50px;
}

.btn-cta-text {
  font-family: DINWeb, sans-serif;
}

.btn-cta-text.normal{
  font-size: 0.9375rem;
}

button i{
  font-size: 1.3rem;
}

.btn-red {
  border: 0;
  background-color: #e81d00;
  color: white;
}
.btn-red:hover {
  background-color: #8a1200;
  color: white;
}

.btn-white {
  border: 1px solid #0f1f28;
  background-color: white;
}
.btn-white:hover {
  background-color: #0f1f28;
  color: #fff;
}

.btn-inverted {
  background-color: #0f1f28;
  border: 1px solid #0f1f28;
  color: white;
  font-family: DINWeb, sans-serif;
  text-decoration: none;
  text-transform: uppercase;
  transition: 0.3s ease-in all;
  cursor: pointer;
}
.btn-inverted:hover {
  background-color: transparent;
  color: #1f1f28;
  border: 1px solid #0f1f28;
}

</style>
